var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { attrs: { id: "sidebar-wrapper" } }, [
    _c("ul", { staticClass: "sidebar-nav", attrs: { id: "sidebar_menu" } }, [
      _c("li", { staticClass: "sidebar-brand" }, [
        _c("label", { class: { active: _vm.status == "online" } }, [
          _c("i", { staticClass: "fas fa-circle fa-sm online" })
        ]),
        _vm._v(" "),
        _c("label", { class: { active: _vm.status == "busy" } }, [
          _c("i", { staticClass: "fas fa-circle fa-sm busy" })
        ]),
        _vm._v(" "),
        _c("label", { class: { active: _vm.status == "offline" } }, [
          _c("i", { staticClass: "fas fa-circle fa-sm offline" })
        ])
      ])
    ]),
    _vm._v(" "),
    _c(
      "ul",
      { staticClass: "sidebar-nav", attrs: { id: "sidebar" } },
      [
        _c(
          "li",
          { class: { active: _vm.$route.name == "ListContact" } },
          [
            _c("router-link", { attrs: { to: { name: "ListContact" } } }, [
              _c("i", { staticClass: "fas fa-user fa-2x" })
            ])
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "li",
          { class: { active: _vm.$route.name == "ListChat" } },
          [
            _c("router-link", { attrs: { to: { name: "ListChat" } } }, [
              _c("i", { staticClass: "fas fa-comment-alt fa-2x" })
            ]),
            _vm._v(" "),
            _c(
              "span",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.msgCount != 0,
                    expression: "msgCount != 0"
                  }
                ],
                staticClass: "badge"
              },
              [_vm._v(_vm._s(_vm.msgCount))]
            )
          ],
          1
        ),
        _vm._v(" "),
        _vm.$store.state.chat.serverConfig.assign_customer ==
        "pull_by_reservation"
          ? [
              _c("li", { staticStyle: { color: "#95eeab" } }, [
                _vm._v("ลูกค้าใหม่")
              ]),
              _vm._v(" "),
              _c(
                "li",
                {
                  staticClass: "nav-new-cust",
                  class: _vm.newCustomerClass,
                  on: { click: _vm.getNextCustomer }
                },
                [
                  _c("i", { staticClass: "fas fa-comment-alt fa-2x" }),
                  _vm._v(" "),
                  _c("span", { staticClass: "new-customer-badge" }, [
                    _vm._v("N")
                  ])
                ]
              )
            ]
          : _vm._e()
      ],
      2
    ),
    _vm._v(" "),
    _vm.showNoti
      ? _c(
          "ul",
          {
            staticStyle: {
              padding: "6px 2px",
              display: "flex",
              "flex-direction": "column",
              "align-items": "center"
            }
          },
          [
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.allowNoti,
                  expression: "allowNoti"
                }
              ],
              staticClass: "uk-checkbox",
              staticStyle: { "margin-bottom": "8px" },
              attrs: { type: "checkbox" },
              domProps: {
                checked: Array.isArray(_vm.allowNoti)
                  ? _vm._i(_vm.allowNoti, null) > -1
                  : _vm.allowNoti
              },
              on: {
                change: [
                  function($event) {
                    var $$a = _vm.allowNoti,
                      $$el = $event.target,
                      $$c = $$el.checked ? true : false
                    if (Array.isArray($$a)) {
                      var $$v = null,
                        $$i = _vm._i($$a, $$v)
                      if ($$el.checked) {
                        $$i < 0 && (_vm.allowNoti = $$a.concat([$$v]))
                      } else {
                        $$i > -1 &&
                          (_vm.allowNoti = $$a
                            .slice(0, $$i)
                            .concat($$a.slice($$i + 1)))
                      }
                    } else {
                      _vm.allowNoti = $$c
                    }
                  },
                  _vm.setNoti
                ]
              }
            }),
            _vm._v(" "),
            _c("span", { staticStyle: { color: "#ffffff" } }, [
              _vm._v("แจ้งเตือน")
            ])
          ]
        )
      : _vm._e(),
    _vm._v(" "),
    _c(
      "ul",
      {
        staticClass: "sidebar-nav",
        staticStyle: { "margin-top": "36px", "font-size": "12px" },
        attrs: { id: "sidebar_menu" }
      },
      [
        _c("li", [
          _c("span", { staticStyle: { color: "white" } }, [
            _vm._v("v" + _vm._s(_vm.appVersion))
          ])
        ])
      ]
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-7d622f5c", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7d622f5c","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Sidebar.vue
// module id = null
// module chunks = 